import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TestDisplayComponent } from './components/test-display/test-display.component';
import { TriggerChoiceDirective } from './directives/trigger-choice.directive';
import { ButtonNavigationComponent } from './components/button-navigation/button-navigation.component';
import { ButtonSetupTwoComponent } from './components/button-navigation/button-setup-two/button-setup-two.component';
import { ButtonSetupOneComponent } from './components/button-navigation/button-setup-one/button-setup-one.component';
import { ButtonSetupFourComponent } from './components/button-navigation/button-setup-four/button-setup-four.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire.component';
import { QuestionComponent } from './components/questionnaire/question/question.component';
import { ForcedChoiceDisplayComponent } from './components/forced-choice-display/forced-choice-display.component';
import { TriggerForcedChoiceDirective } from './directives/trigger-forced-choice.directive';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DragulaModule } from 'ng2-dragula';
import { DragNDropComponent } from './components/questionnaire/drag-n-drop/drag-n-drop.component';
import { SliderComponent } from './components/questionnaire/slider/slider.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import { InstructionContainerBgFullComponent } from './components/instruction-container-bg-full/instruction-container-bg-full.component';
import { InstructionContainerBgHalfComponent } from './components/instruction-container-bg-half/instruction-container-bg-half.component';
import { InstructionContainerBgMonoComponent } from './components/instruction-container-bg-mono/instruction-container-bg-mono.component';
import { ContinueButtonComponent } from './components/continue-button/continue-button.component';
import { ContinueButtonLightComponent } from './components/continue-button-light/continue-button-light.component';
import { ConsentFormComponent } from './components/consent-form/consent-form.component';
import { DisplayComponent } from './components/display/display.component';
import { OverviewComponent } from './components/overview/overview.component';
import { OverviewBlockComponent } from './components/overview-block/overview-block.component';
import { CountdownTimerComponent } from './components/countdown-timer/countdown-timer.component';
import { InstructionContainerComponent } from './components/instruction-container/instruction-container.component';
import { IntermissionComponent } from './components/intermission/intermission.component';
import { ImageFullComponent } from './components/image-full/image-full.component';
import { LikertComponent } from './components/questionnaire/likert/likert.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestInterceptorService } from './services/request-interceptor.service';
import { MediaDisplayComponent } from './components/media-display/media-display.component';
import { IATDisplayComponent } from './components/iat-display/iat-display.component';
import { PrimingDisplayComponent } from './components/priming-display/priming-display.component';
import { ConjointDisplayComponent } from './components/conjoint-display/conjoint-display.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionInterceptor } from './interceptors/subscription.interceptor';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { appReducer } from '../state/app.state';
import { ConfigEffects } from 'src/state/config/config.effects';


registerLocaleData(localeDe, 'de-DE', localeDeExtra);

@NgModule({
  declarations: [
    AppComponent,
    TestDisplayComponent,
    TriggerChoiceDirective,
    ButtonNavigationComponent,
    ButtonSetupTwoComponent,
    ButtonSetupOneComponent,
    ButtonSetupFourComponent,
    NavbarComponent,
    QuestionnaireComponent,
    QuestionComponent,
    ForcedChoiceDisplayComponent,
    TriggerForcedChoiceDirective,
    DragNDropComponent,
    SliderComponent,
    InstructionsComponent,
    InstructionContainerBgFullComponent,
    InstructionContainerBgHalfComponent,
    InstructionContainerBgMonoComponent,
    ContinueButtonComponent,
    ContinueButtonLightComponent,
    ConsentFormComponent,
    DisplayComponent,
    OverviewComponent,
    OverviewBlockComponent,
    CountdownTimerComponent,
    InstructionContainerComponent,
    IntermissionComponent,
    ImageFullComponent,
    LikertComponent,
    MediaDisplayComponent,
    IATDisplayComponent,
    PrimingDisplayComponent,
    ConjointDisplayComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DragulaModule.forRoot(),
    HttpClientModule,
    PdfViewerModule,
    NgbModule,
    StoreModule.forRoot(appReducer,),
    EffectsModule.forRoot([ConfigEffects]),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SubscriptionInterceptor, multi: true },
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
    {
      provide: 'BASE_URL',
      useFactory: function getBaseUrl() {
        return (
          document.getElementsByTagName('base')[0].attributes[0].value || '/'
        );
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
